import { lazy } from 'react';

const LazySupplyingShoppingCartDrawer = lazy(() => import('./shopping-cart-drawer'));
const LazyMyOrders = lazy(() => import('./my-orders'));
const LazyMySession = lazy(() => import('./my-profile'));
const LazyStaticPages = lazy(() => import('./static-page'));
const LazySuggestedProductsPages = lazy(() => import('./suggested-products'));
const LazyPromotionProductsPages = lazy(() => import('./promotion-products'));
const LazyNotFound = lazy(() => import('./errors/not-found'));
const LazyLogout = lazy(() => import('./authentication/logout'));
const LazyCheckout = lazy(() => import('./checkout'));
const LazyHome = lazy(() => import('./home'));
const LazySearchResults = lazy(() => import('./search-results'));
const LazyProductDetail = lazy(() => import('./product-detail'));
const LazyCategoryCatalog = lazy(() => import('./category-catalog'));
const LazySubcategoryCatalog = lazy(() => import('./subcategory-catalog'));
const LazyMenuEntries = lazy(() => import('shared/components/navigation-ui/menu-entries'));
const LazyLoyaltyValidationPage = lazy(() => import('./loyalty-validation/loyalty-validation.page'));
const LazyMaintenancePage = lazy(() => import('./maintenance/maintenance'));
const LazyAutoprospectSuccessPage = lazy(() => import('./autoprospect-success/autoprospect-success'));
const LazyWelcomeDeeplinkPage = lazy(() => import('./welcome-deeplink/welcome-deeplink'));

export {
  LazyAutoprospectSuccessPage,
  LazyCategoryCatalog,
  LazyCheckout,
  LazyHome,
  LazyLogout,
  LazyLoyaltyValidationPage,
  LazyMaintenancePage,
  LazyMenuEntries,
  LazyMyOrders,
  LazyMySession,
  LazyNotFound,
  LazyProductDetail,
  LazyPromotionProductsPages,
  LazySearchResults,
  LazyStaticPages,
  LazySubcategoryCatalog,
  LazySuggestedProductsPages,
  LazySupplyingShoppingCartDrawer,
  LazyWelcomeDeeplinkPage,
};
